'use client';

import { useQuality } from '@/components/shared/QualityProvider';

/**
 * Project register header rendered on mobile (low tier) below the intro
 * logo break overlay. Mirrors the header at the top of `/grid` so mobile
 * users land on a coherent "project register" page once the explosion
 * fades.
 *
 * Visibility / fade-in is owned by the surrounding `MobileIntroGate` —
 * this component only handles the tier gate + content.
 */
export function MobileGridIntro({
  tag,
  title,
  intro,
}: {
  tag: string;
  title: string;
  intro: string;
}) {
  const { tier } = useQuality();
  if (tier !== 'low') return null;

  return (
    <section className="mx-auto flex w-full flex-col gap-10 px-6 pt-16 pb-12">
      <header className="project-register-header">
        <span className="project-register-header__tag">{tag}</span>
        <h1 className="project-register-header__title">{title}</h1>
        <p className="project-register-header__intro">{intro}</p>
      </header>
    </section>
  );
}
